import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { 
  FireIcon, 
  BookOpenIcon, 
  ChartBarIcon, 
  UserGroupIcon,
  PlusIcon,
  AcademicCapIcon,
  TrophyIcon,
  ClockIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

// Composants des sections
import WorkoutPlansList from '../../components/workouts/WorkoutPlansList';
import ExerciseLibrary from '../../components/workouts/ExerciseLibrary';
import MemberProgress from '../../components/workouts/MemberProgress';
import WorkoutPlanForm from '../../components/workouts/WorkoutPlanForm';
import CoachesPrograms from '../../components/workouts/CoachesPrograms';

const WorkoutPlansPage = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('plans');
  const [showPlanForm, setShowPlanForm] = useState(false);

  const tabs = [
    {
      id: 'plans',
      name: 'Plans d\'entraînement',
      icon: FireIcon,
      component: WorkoutPlansList,
      description: 'Créer et gérer les programmes d\'entraînement'
    },
    {
      id: 'exercises',
      name: 'Bibliothèque d\'exercices',
      icon: BookOpenIcon,
      component: ExerciseLibrary,
      description: 'Catalogue complet des exercices disponibles'
    },
    {
      id: 'progress',
      name: 'Suivi des membres',
      icon: ChartBarIcon,
      component: MemberProgress,
      description: 'Progression et statistiques des membres'
    },
    {
      id: 'coaches',
      name: 'Coachs & Programmes',
      icon: AcademicCapIcon,
      component: CoachesPrograms,
      description: 'Attribution des programmes aux coachs'
    }
  ];

  const ActiveTabComponent = tabs.find(tab => tab.id === activeTab)?.component || (() => <div>Contenu en développement</div>);

  const handleSavePlan = (planData) => {
    console.log('Plan sauvegardé:', planData);
    setShowPlanForm(false);
    // Ici, logique pour sauvegarder le plan dans la base de données
  };

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-white">
            Plans d'entraînement
          </h1>
          <p className="text-white/60 mt-2">
            Gérez les programmes d'entraînement et suivez la progression des membres
          </p>
        </div>
        {activeTab === 'plans' && (
          <button
            onClick={() => setShowPlanForm(true)}
            className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-3 rounded-xl font-semibold hover:from-orange-600 hover:to-red-600 transition-all duration-300 flex items-center space-x-2 shadow-lg"
          >
            <PlusIcon className="h-5 w-5" />
            <span>Nouveau plan</span>
          </button>
        )}
      </div>

      {/* Onglets */}
      <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-2 border border-white/20">
        <div className="flex space-x-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-2xl font-medium transition-all duration-300 ${
                activeTab === tab.id
                  ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg'
                  : 'text-white/80 hover:bg-white/10 hover:text-white'
              }`}
            >
              <tab.icon className="h-5 w-5" />
              <span>{tab.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Description de l'onglet actif */}
      <div className="bg-white/5 backdrop-blur-lg rounded-2xl px-6 py-3 border border-white/10 mb-4">
        <p className="text-white/70">
          {tabs.find(tab => tab.id === activeTab)?.description}
        </p>
      </div>

      {/* Contenu de l'onglet actif */}
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <ActiveTabComponent />
      </motion.div>

      {/* Modal pour ajouter/modifier un plan */}
      {showPlanForm && (
        <WorkoutPlanForm
          onClose={() => setShowPlanForm(false)}
          onSave={handleSavePlan}
        />
      )}
    </div>
  );
};

export default WorkoutPlansPage; 